import React from 'react';
import PropTypes from 'prop-types';
import { perfMarkerPropTypes } from '@bingads-webui/performance-marker';
import { ManagedSettingsSummary } from './settings-summary-page';
import { getDeps } from './summary-legacy-deps-list';
import { initializeWithLegacyDependencies } from './get-injected-dependencies';

class SettingsSummary extends React.PureComponent {
  render() {
    this.p$legacyInit = initializeWithLegacyDependencies(this.props, getDeps);
    return (
      <ManagedSettingsSummary
        i18n={this.props.i18n}
        p$legacyInit={this.p$legacyInit}
        serverContext={this.props.serverContext}
        scope={this.props.scope}
        preferenceService={this.props.preferenceService}
        permissions={this.props.permissions}
        perfMarker={this.props.perfMarker}
        prefetchChunks={this.props.prefetchChunks}
      />);
  }
}

SettingsSummary.propTypes = {
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.object.isRequired,
    CurrentCustomer: PropTypes.object.isRequired,
  }),
  scope: PropTypes.shape({
    values: {
      adGroupId: PropTypes.number,
      campaignId: PropTypes.number,
    },
  }).isRequired,
  permissions: PropTypes.shape({
  }),
  classes: PropTypes.shape({
    pageContainer: PropTypes.string.isRequired,
    settingsFormContainer: PropTypes.string.isRequired,
  }).isRequired,
  currentCampaign: PropTypes.shape({}),
  currentAdGroup: PropTypes.shape({}),
  preferenceService: PropTypes.shape({}).isRequired,
  perfMarker: perfMarkerPropTypes.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  prefetchChunks: PropTypes.func.isRequired,
};

SettingsSummary.defaultProps = {
  serverContext: {},
  permissions: {},
  currentCampaign: null,
  currentAdGroup: null,
};

export const SettingsSummaryView = SettingsSummary;

